import * as styles from './index.module.scss';

import Image from 'next/image';

const CategoryDudeImage = ({ category = {} }) => (
  <div className={styles['category-dude-container']}>
    <div className={`container ${styles['container']}`}>
      <picture>
        <source srcSet={category.category_dude_image} type="image/webp" />
        <Image
          src={category.category_dude_image_fallback}
          alt={category.name}
          quality={80}
          placeholder="blur"
          blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
        />
      </picture>
    </div>
  </div>
);

export default CategoryDudeImage;
